const selectIsRequestNewPasswordSent = state => state.newPasswordContainer.item || {};


export default { selectIsRequestNewPasswordSent };
